import React from "react";
import "./LegalNew.css";
import { FiShield, FiCheckCircle } from "react-icons/fi";

export default function PrivacyPolicy() {
  const legalId = "BAILCP-V-PP-2.2";
  const lastUpdated = "December 8, 2025";

  const sections = [
    {
      title: "Information We Collect",
      icon: <FiCheckCircle className="section-icon" />,
      items: [
        "Personal identification information: name, email address, phone number, and profile details you provide.",
        "Usage data: how you interact with our platform, including pages visited, features used, and time spent.",
        "Device information: browser type, operating system, IP address, and device identifiers.",
        "Learning data: your progress, quiz results, and AI interactions for personalized learning experiences.",
      ],
    },
    {
      title: "How We Use Your Information",
      icon: <FiCheckCircle className="section-icon" />,
      items: [
        "To provide and maintain our AI-powered learning services and personalize your experience.",
        "To communicate with you about updates, features, and support-related matters.",
        "To analyze usage patterns and improve our platform's functionality and content.",
        "To detect, prevent, and address technical issues and security threats.",
      ],
    },
    {
      title: "Data Sharing & Third Parties",
      icon: <FiCheckCircle className="section-icon" />,
      items: [
        "We do not sell your personal information to third parties for marketing purposes.",
        "We may share data with service providers who assist in operating our platform under strict confidentiality agreements.",
        "We may disclose information when required by law or to protect our rights and the safety of users.",
        "In the event of a merger or acquisition, your data may be transferred to the new entity with continued protection.",
      ],
    },
    {
      title: "Data Security & Protection",
      icon: <FiCheckCircle className="section-icon" />,
      items: [
        "We implement industry-standard encryption protocols to protect data in transit and at rest.",
        "Access to personal data is restricted to authorized personnel who need it to perform their duties.",
        "We conduct regular security audits and vulnerability assessments to maintain data protection.",
        "We maintain incident response procedures to address any potential data breaches promptly.",
      ],
    },
    {
      title: "Your Rights & Choices",
      icon: <FiCheckCircle className="section-icon" />,
      items: [
        "You have the right to access, correct, or delete your personal information at any time.",
        "You can opt out of marketing communications while still receiving essential service updates.",
        "You may request a copy of your data in a portable format for transfer to another service.",
        "You can adjust your privacy settings within your account dashboard at any time.",
      ],
    },
  ];

  return (
    <div className="legal-wrapper">

      {/* Back Link */}
      <a href="/legal" className="legal-back">← Back to Legal Center</a>

      {/* Header */}
      <div className="legal-header">
        <FiShield className="legal-header-icon" />
        <h1 className="legal-title">
          Privacy Policy <span className="blink-dot"></span>
        </h1>

        <div className="legal-meta-box">
          <span>
            Legal ID: <strong className="legal-id">{legalId}</strong>
          </span>
          <span className="divider">|</span>
          <span>
            Last Updated: <strong className="legal-updated">{lastUpdated}</strong>
          </span>
        </div>
      </div>

      {/* Render All Sections */}
      {sections.map((sec, index) => (
        <div className="legal-section-box" key={index}>
          <div className="legal-section-number">{index + 1}</div>

          <div className="section-header">
            {sec.icon}
            <h2>{sec.title}</h2>
          </div>

          <ul className="legal-bullets">
            {sec.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
